<template>
  <div class="pa-front-page pa-front-page-registration">
    <FrontPageLogo />

    <router-view></router-view>

    <PaIndexFooter />
  </div>
</template>

<script>
import FrontPageLogo from '@/components/FrontParts/FrontPageLogo/FrontPageLogo.vue'
import PaIndexFooter from '@/components/FrontParts/PaIndexFooter/PaIndexFooter.vue'

export default {
  components : {
    FrontPageLogo,
    PaIndexFooter
  },
}
</script>

<style lang="scss">
.pa-front-page{
  &-registration{
  }
}
</style>
